import React from 'react';
export const Banner00DataSource = {
  wrapper: { className: 'banner0 l4zb8kb2avq-editor_css' },
  textWrapper: { className: 'banner0-text-wrapper' },
  title: {
    className: 'banner0-title l4zb8n1hn4h-editor_css',
    children:
      'https://forestgame.oss-cn-beijing.aliyuncs.com/%E5%AE%98%E7%BD%91%E8%B5%84%E6%BA%90/forestgame_logo_new.png',
  },
  content: {
    className: 'banner0-content l4zb9uzdx3-editor_css',
    children: (
      <span>
        <span>
          <span>
            <span>
              <p>我们是武汉森林时代科技有限公司</p>
            </span>
          </span>
        </span>
      </span>
    ),
  },
  button: {
    className: 'banner0-button l4zbgc2ljs-editor_css',
    children: (
      <span>
        <span>
          <span>
            <span>
              <p>TapTap主页</p>
              <p>
                <br />
              </p>
            </span>
          </span>
        </span>
      </span>
    ),
    href: 'https://www.taptap.com/developer/66498',
    target: '_blank',
  },
};
export const Content00DataSource = {
  wrapper: { className: 'home-page-wrapper content0-wrapper' },
  page: { className: 'home-page content0' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <p>
              <span>我们的游戏</span>
              <br />
            </p>
          </span>
        ),
      },
    ],
  },
  childWrapper: {
    className: 'content0-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'content0-block',
        md: 8,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon',
              children:
                'https://forestgame.oss-cn-beijing.aliyuncs.com/%E5%AE%98%E7%BD%91%E8%B5%84%E6%BA%90/%E5%B0%8F%E5%B2%9Blogo-512.png',
            },
            {
              name: 'title',
              className: 'content0-block-title',
              children: (
                <span>
                  <p>恐龙小岛</p>
                </span>
              ),
            },
            {
              name: 'content',
              children: (
                <span>
                  <span>
                    <p>恐龙世界沙盒生存模拟手游</p>
                  </span>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block1',
        className: 'content0-block',
        md: 8,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon',
              children:
                'https://forestgame.oss-cn-beijing.aliyuncs.com/%E5%AE%98%E7%BD%91%E8%B5%84%E6%BA%90/%E5%B0%8F%E6%81%90%E9%BE%99logo_512.png',
            },
            {
              name: 'title',
              className: 'content0-block-title',
              children: (
                <span>
                  <p>梦幻派对</p>
                </span>
              ),
            },
            {
              name: 'content',
              children: (
                <span>
                  <span>
                    <p>可爱小恐龙联机派对竞技手游</p>
                  </span>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block2',
        className: 'content0-block',
        md: 8,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon',
              children:
                'https://forestgame.oss-cn-beijing.aliyuncs.com/%E5%AE%98%E7%BD%91%E8%B5%84%E6%BA%90/%E4%B8%89%E6%9C%88%E4%B9%8B%E5%BA%ADlogo-512.png',
            },
            {
              name: 'title',
              className: 'content0-block-title',
              children: (
                <span>
                  <p>三月之庭</p>
                </span>
              ),
            },
            {
              name: 'content',
              children: (
                <span>
                  <p>唯美日系箱庭解谜手游</p>
                </span>
              ),
            },
          ],
        },
      },
    ],
  },
};
export const Footer00DataSource = {
  wrapper: { className: 'home-page-wrapper footer0-wrapper' },
  OverPack: { className: 'home-page footer0', playScale: 0.05 },
  copyright: {
    className: 'copyright',
    children: (
      <span>
        <span>
          <span>
            <span>
              <span>
                <span>
                  <span>
                    ©2022 ForestGame&nbsp;All Rights Reserved.&nbsp; &nbsp;
                    &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 
                  </span>
                </span>
              </span>
              <span><a href="https://beian.miit.gov.cn/" target="_blank">ICP License: 鄂ICP备18021612号-1</a></span>
              <span>
                <p>
                  <br />
                </p>
              </span>
            </span>
          </span>
        </span>
      </span>
    ),
  },
};
